// extracted by mini-css-extract-plugin
export default {"heading":"at-z","corrected":"bt-z","redirectVerbiageContainer":"ct-z","redirectVerbiageText":"dt-z"};